<template>
    <div class="ec-bike-listing-controls">
        <div class="container-fluid">
            <div class="row">
                <bike-listing-filters-button
                        v-if="!hideFilters"
                        @click="toggleFilters"
                        :filters-open="filtersOpen"></bike-listing-filters-button>
                <div class="col-xs-5 col-sm-4 col-md-3 col-lg-2" v-if="hideFilters"></div>
                <bike-listing-sorting-button></bike-listing-sorting-button>
            </div>
        </div>
        <transition name="fade">
            <bike-listing-filters-box v-if="filtersOpen"></bike-listing-filters-box>
        </transition>
    </div>
</template>

<style lang="scss" type="text/scss">
    @import "../../../sass/variables";
    @import "../../../sass/mixins";

    .ec-bike-listing-controls {
        background: $ec-bike-info-background;

        .row {
            height: $ec-bike-listing-controls-height;
        }
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s
    }

    .fade-enter, .fade-leave-to {
        opacity: 0
    }
</style>

<script type="text/babel">
    import BikeListingFiltersBox from './BikeListingFiltersBox.vue';
    import BikeListingFiltersButton from './BikeListingFiltersButton.vue';
    import BikeListingSortingButton from './BikeListingSortingButton.vue';

    const GA = require('../../modules/ga');

    export default {
        props: ['hideFilters'],

        data: function () {
            return {
                filtersOpen: false
            };
        },

        methods: {
            toggleFilters: function () {
                this.filtersOpen = !this.filtersOpen;

                GA.event('filters', this.filtersOpen ? 'open' : 'close', 'Toggle bike listing filters box');
            }
        },

        components: {
            'bike-listing-filters-box': BikeListingFiltersBox,
            'bike-listing-filters-button': BikeListingFiltersButton,
            'bike-listing-sorting-button': BikeListingSortingButton
        }
    }
</script>